import { getPhotosForPhotowall } from 'entities/photos';

Pixlee.module('CoverflowApp.Show', function(Show, App, _Backbone, _Marionette, $) {
    Show.Controller = App.Controllers.Application.extend({
        initialize: function(options) {
            var collectionView, headerView;
            var layout = new Show.Layout(options);
            var _this = this;
            this.listenTo(layout, 'show', function() {
                var photoscollection = getPhotosForPhotowall();
                collectionView = new Show.CoverflowCollection({
                    collection: photoscollection,
                    displayOptions: options.display_options
                });
                layout.collection = photoscollection;
                photoscollection.on('sync', function(collection, resp) {
                    if (_this.widgetloaded) {
                        return false;
                    }
                    _this.widgetloaded = true;
                    gon.sortType = resp.sortType;

                    var hasTile = options.display_options.headerOptions.end_tile_upload_button_background_showHide;
                    if (collectionView.sly || hasTile) {
                        var rel = collectionView.sly ? collectionView.sly.rel : {};
                        App.commands.execute('opened:horizontal', rel, photoscollection, true);
                    }
                });
                headerView = new Show.HeaderView({
                    model: App.currentAlbum,
                    displayOptions: options.display_options
                });
                this.show(collectionView, {
                    region: layout.frame
                });
                this.show(headerView, {
                    region: layout.widget_header_region
                });
                if (!_.isFalsy(options.display_options.is_interactive)) {
                    var viewCommand = gon.isMobile ? 'get:navbar:mobile:view' : 'get:navbar:view';
                    var navbarView = App.request(viewCommand, options, photoscollection);
                    this.show(navbarView, {
                        region: layout.interactive_region
                    });
                }
                if (App.isDesktop && !_.isFalsy(gon.previewMode)) {
                    var header_sponserImage_input;
                    App.commands.setHandler('stylesheet:generated', function(css, params) {
                        header_sponserImage_input = header_sponserImage_input || params.header_sponserImage_input;
                        if (params.widget_photoSize != '250') {
                            _.debounce(collectionView.triggerMethod('reload:sly'), 500);
                        }
                        if (!_.isFalsy(params.header_sponserImage_input)) {
                            header_sponserImage_input = params.header_sponserImage_input;
                            App.displayOptions.set('header_sponserImage_input', header_sponserImage_input);
                            headerView = _this.getHeaderView({
                                model: App.currentAlbum,
                                displayOptions: options.display_options
                            });
                            _this.show(headerView, {
                                region: layout.widget_header_region
                            });
                        }
                        collectionView.triggerMethod('stylesheet:generated');
                    });
                }
            });
            this.show(layout, {
                loading: true
            });
        },
    });

});
